import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINT$ } from 'src/app/shared/index';
import { DataService } from '../../services/data.service';
@Injectable()
export class EnergyService {
  // iep/energyService/v1/load/energy/{siteid}/{fromdate}/{todate}
  private energyUrl = `${API_ENDPOINT$}/energy/energy`;
  // iep/energyService/v1/site/shiftwiseenergy/{siteid}/{fromdate}/{todate}
  private shiftwiseenergyUrl = `${API_ENDPOINT$}/energy/shiftwiseenergy`;
  private energyTrendUrl = `${API_ENDPOINT$}/energy/getEnergyTrends`;
  private realtimeDataUrl = `${API_ENDPOINT$}/energy/getRealtimeData`;
  private fetchDataForEbyQAnalysisUrl = `${API_ENDPOINT$}/common/fetchDataForEbyQAnalysis`;
  private getProductsBySiteIdUrl = `${API_ENDPOINT$}/common/getProductsBySiteId`;

  private getEnergySourcingShiftWiseUrl = `${API_ENDPOINT$}/energy/getEnergySourcingShiftWise`;
  private getEnergyLossUrl = `${API_ENDPOINT$}/energy/getEnergyLoss`;
  constructor(private dataService: DataService) {}
  public getShiftwiseenergy = (
    siteId: string,
    fromDate: string,
    toDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.shiftwiseenergyUrl}/${siteId}/${fromDate}/${toDate}`
    );
  };
  public getEnergyPareto = (
    siteId: string,
    fromDate: string,
    toDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.energyUrl}/${siteId}/${fromDate}/${toDate}`
    );
  };
  // eslint-disable-next-line max-len
  public getEnergyTrendsData = (
    siteId: string,
    fromDate: string,
    toDate: string,
    timebase: string,
    meterIds: any,
    enableShiftwise: boolean,
    nodeType: string,
    showidleEnergy: boolean
  ) => {
    // eslint-disable-next-line max-len
    const model = {
      siteId: siteId,
      fromDate: fromDate,
      toDate: toDate,
      timebase: timebase,
      meterId: meterIds,
      enableShiftwise: enableShiftwise,
      nodeType: nodeType,
      showidleEnergy: showidleEnergy
    };
    return this.dataService.postData(this.energyTrendUrl, model);
  };
  public getRealtimeData = (
    siteId: string,
    startDate: string,
    endDate: string,
    meterId: string,
    loadId: string
  ): Observable<any> => {
    // eslint-disable-next-line max-len
    const model = {
      siteId: siteId,
      startDate: startDate,
      endDate: endDate,
      meterId: meterId,
      loadId: loadId
    };
    return this.dataService.postData(this.realtimeDataUrl, model);
  };
  public fetchDataForEbyQAnalysis = (params: any): Observable<any> => {
    return this.dataService.postData(this.fetchDataForEbyQAnalysisUrl, params);
  };
  public getProductsBySiteId = (
    siteId: String,
    loadId: String
  ): Observable<any> => {
    const model = { siteId: siteId, loadId: loadId };
    return this.dataService.postData(this.getProductsBySiteIdUrl, model);
  };
  public getEnergySourcingShiftWise = (
    siteId: string,
    fromDate: string,
    toDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getEnergySourcingShiftWiseUrl}/${siteId}/${fromDate}/${toDate}`
    );
  };
  public getEnergyLoss = (
    siteId: string,
    fromDate: string,
    toDate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getEnergyLossUrl}/${siteId}/${fromDate}/${toDate}`
    );
  };
}
